import { filter, get, map, orderBy, values } from 'lodash'
import { createSelector } from 'reselect'
import { isAfterBusinessDate } from '../utils/businessHours'

const getEventTypesById = (state) => get(state, 'salesEvent.eventTypes.byId', {})

const getEvent = (state, eventId) => get(state, ['salesEvent', 'byId', eventId], {})

const getEvents = (state) => {
  const eventTypesById = getEventTypesById(state)
  const allEvents = values(get(state, 'salesEvent.byId', {}))
  const mappedEvents = map(allEvents, (event) => {
    const eventType = eventTypesById[get(event, 'salesEventTypeId', {})]

    return {
      ...event,
      eventType: get(eventType, 'name')
    }
  })

  const events = filter(mappedEvents, isAfterBusinessDate)

  return orderBy(events, 'startTime')
}

export const getEventsLoading = (state) => get(state, 'salesEvent.requestLoading', false)

export const makeGetEvents = () => createSelector(
  getEvents,
  getEventTypesById,
  (events) => events
)

export const getCurrentEventId = (state) => get(state, 'salesEvent.activeEventId')

export const getCurrentEvent = (state) => getEvent(state, getCurrentEventId(state), {})

export const makeGetCurrentEvent = () => createSelector(
  getCurrentEvent,
  (event) => event
)

export const getCurrentEventType = (state) => {
  const eventTypes = getEventTypesById(state)
  const getCurrentEvent = makeGetCurrentEvent()
  const currentEvent = getCurrentEvent(state)
  const currentEventTypeId = currentEvent?.salesEventTypeId
  return get(eventTypes, `${currentEventTypeId}.name`)
}
